import { FormInstance } from "antd";
import { useCallback, useState } from "react";
import { AdministrationGeneralPut } from "../../../../types/AdministrationGeneral";
import { useAppDispatch } from "../../../../store";
import { editNextNumber } from "../../../../acions/administration/general";
import { transformToFloat } from "../../../../lib/transformToFloat";

export const useUpdate = (
  form: FormInstance,
  setIsEdit: React.Dispatch<React.SetStateAction<boolean>>,
  setInitialValue: React.Dispatch<React.SetStateAction<number | null>>
) => {
  const dispatch = useAppDispatch();

  const [isSaving, setIsSaving] = useState(false);

  const update = useCallback(async () => {
    try {
      if (!isSaving) {
        const values: any = await form.validateFields();

        const request: AdministrationGeneralPut = {
          nextContractNumber: transformToFloat(values.nextContractNumber) || 0,
        };

        setIsSaving(true);

        await Promise.resolve(dispatch(editNextNumber(request)));

        setInitialValue(values.nextContractNumber);

        setIsSaving(false);

        setIsEdit(false);
      }
    } catch {
      setIsSaving(false);
    }
  }, [dispatch, form, isSaving, setIsEdit, setInitialValue]);

  return { isSaving, update };
};
